export default __webpack_public_path__ + "img/c70b8132e3c27f684455dc825da8ed68.png";